import FinanceChoosePriorityPage from "./ChoosePriority";

export default function FinanceDiagnostic(props) {
  return <FinanceChoosePriorityPage/>
}
